import SelectedCountriesHandler from '../../utils/selected-countries-handler';
import CountriesModule from '../../modules/countries-module';
import ExpertisesModule from '../../modules/expertises-module';

class Main {
	constructor() {
        this.metaDescription = document.getElementById('meta-description');
        this.selCountries = new SelectedCountriesHandler();
		this.countriesModule = new CountriesModule(this.selCountries);
		this.expertisesModule = new ExpertisesModule(this.countriesModule);
	}

	run() {
        if (!!this.metaDescription) {
            document.title = 'Mustergutachten - anabin: Infoportal zu ausländischen Bildungsabschlüssen';
        }
		this.countriesModule.getCountries().then(() => {
			this.initializeModules();

			this.selCountries.getAllSelectedCountries().forEach(countryObject => {
				if (countryObject) {
					// const countryArray = countryObject.split(':');
					// this.countriesModule.selectCountry(null, countryArray[0], countryArray[1]);
                    this.countriesModule.selectCountry(null, countryObject)
				}
			});
			this.countriesModule.renderCountryOption(this.countriesModule.countries);
			this.expertisesModule.getData().then();
		});
	}


	initializeModules() {
		this.countriesModule.initialiseModules(this.expertisesModule);
		this.expertisesModule.initialise();
		this.expertisesModule.dataTable.modalDom.addEventListener();
	}
}
const main = new Main();
main.run();


